import { useEffect } from "react";

import { useNavigate } from "react-router-dom";

export default function NotFoundPage() {
  const navigate = useNavigate();

  useEffect(() => {
    // Immediately redirect to dashboard/episodes list
    navigate("/episodes", { replace: true });
  }, [navigate]);

  // Return null since we're redirecting immediately
  return null;
}
